import { Injector, Pipe, PipeTransform } from '@angular/core';
import ColorCodingService from '@app/services/color-coding.service';
import {
    SearchForProjectListingResponseModel,
    SearchListingResponseModel,
    SearchOfClientResponseModel,
} from '@shared/service-proxies/service-proxies';
import { isNil } from 'lodash';

@Pipe({
    name: 'searchStatusClass',
    standalone: true,
})
class SearchStatusClassPipe implements PipeTransform {

    colorCodingService: ColorCodingService;

    constructor(injector: Injector) {
        this.colorCodingService = injector.get(ColorCodingService);
    }

    transform(search?:
    SearchListingResponseModel |
    SearchOfClientResponseModel |
    SearchForProjectListingResponseModel): string {
        if (isNil(search)) {
            return '';
        }

        return this.colorCodingService.getSearchColorCoding(search);
    }
}

export default SearchStatusClassPipe;
